import moment from 'moment-timezone';
import apiClient from '../../api/index';
import {
  GetCurrentUserDataResponse,
  GetUserCompaniesResponse,
  IUserService
} from './contracts/user.service';
import { IUserCompanyDetails } from 'types/user';

export const UserService: IUserService = {
  async getCurrentUserData(): Promise<GetCurrentUserDataResponse> {
    const response = await apiClient.request('GET', '/identity/me');
    moment.tz.setDefault(response.data.timezone); // TODO: coolgsus: look for a better place to put this;
    return response.data as GetCurrentUserDataResponse;
  },
  async getUserCompanies(): Promise<GetUserCompaniesResponse> {
    const response = await apiClient.request('GET', '/identities/companies');
    return response as GetUserCompaniesResponse;
  },
  async getAvailableCompanies(): Promise<IUserCompanyDetails[]> {
    const response = await apiClient.request('GET', '/identities/corporations');
    return response as IUserCompanyDetails[];
  }
};
